/* eslint-disable react/react-in-jsx-scope */
import React from 'react'

import { Priority } from '../../../models/API'
import FormSelectInput from '../elements/FormSelectInput'

interface SubCategoryInputProps {
  subCategories?: { label: string; options: Priority[]; required?: boolean }
  formDisabled?: boolean
}

/**
 * Shared subCategory select input.
 * Renders a dropdown of subcategory options sorted by priority.
 */
const SubCategoryInput = ({
  subCategories,
  formDisabled,
}: SubCategoryInputProps) => {
  if (!subCategories || Object.keys(subCategories).length === 0) return null

  return (
    <FormSelectInput
      name="subCategory"
      label={subCategories.label}
      autoComplete="new-subCategory"
      placeholder={`Select ${subCategories.label}`}
      disabled={formDisabled}
      options={subCategories.options
        .sort((a, b) => a.priority - b.priority)
        .map((value: Priority) => ({
          value: value.name,
          text: value.name,
        }))}
      required={'required' in subCategories && !!subCategories.required}
    />
  )
}

export default SubCategoryInput
